export enum PagesType {
  tourHome = 'WPT_HOME',
  primeHome = 'PRIME_HOME',
  mainHome = 'MAIN_HOME',
  immigrationHome = 'IMMIGRATION_GUIDE_HOME',
}
